module.exports = __webpack_public_path__ + "static/media/clock.b01578ec.png";